<template>
  <div class="popup-wrapper" v-if="visible">
    <Form ref="inquiryRef" :initial-values="inquiryInitValues">
      <div class="popup">
        <img src="@/assets/imgs/common/close.png" alt="닫기" class="close" @click="clickCloseModal" />
        <p class="title-text">1:1 문의하기</p>
        <div class="name-wrapper">
          <Field v-model="inquiryInitValues.name" id="name" name="name" label="이름" rules="required" v-slot="{ field }">
            <label for="name">이름 <span class="required">*</span></label>
            <input type="text" v-bind="field" name="name" id="name" placeholder="이름을 입력해주세요." />
          </Field>

          <Field v-model="inquiryInitValues.email" id="email" name="email" label="E-mail" rules="required|email" v-slot="{ field }">
            <label for="email">E-mail <span class="required">*</span></label>
            <input type="text" v-bind="field" name="email" id="email" placeholder="E-mail을 입력해주세요." />
          </Field>

          <Field v-model="inquiryInitValues.mobile" id="mobile" name="mobile" label="연락처" rules="required" v-slot="{ field }">
            <label for="mobile">연락처 <span class="required">*</span></label>
            <input type="text" v-bind="field" name="mobile" id="mobile" placeholder="연락처를 입력해주세요." />
          </Field>

          <Field v-model="inquiryInitValues.qaContents" id="qaContents" name="qaContents" label="문의사항" rules="required" v-slot="{ field }">
            <label for="qaContents">문의사항 <span class="required">*</span></label>
            <textarea class="inquriry" v-bind="field" name="qaContents" id="qaContents" cols="30" rows="10"></textarea>
          </Field>

          <div class="agree">
            <Field :value="true" type="checkbox" v-model="inquiryInitValues.isAgree" id="isAgree" name="isAgree" label="개인정보 수집 및 이용" rules="required" v-slot="{ field }">
              <input :value="true" type="checkbox" v-bind="field" class="pointer" id="isAgree" />
              <label for="agree-text" class="ml-10px pointer agree-text" @click="isVisibleModal = true">개인정보 수집 및 이용에 동의합니다.</label>
            </Field>
          </div>
        </div>

        <div class="txt-right">
          <button class="submit" @click.prevent="onSubmit">확인</button>
        </div>
      </div>
    </Form>
  </div>
  <InquiryDesc :visible="isVisibleModal" @closeModal="agreeDescModal"></InquiryDesc>
</template>

<script>
import { ref } from "@vue/reactivity";
import InquiryDesc from "./InquiryDesc.vue";
import { sugangQaApi } from "@/api/itmApi/index";
import { watch } from "@vue/runtime-core";
export default {
  components: {
    InquiryDesc,
  },
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    pageIdx: {
      type: String,
      required: false,
      default: "-1",
    },
  },
  emits: ["closeModal"],
  setup(props, cotext) {
    const isVisibleModal = ref(false);
    const inquiryRef = ref(null);

    const inquiryInitValues = {
      email: "",
      mobile: "",
      name: "",
      qaContents: "",
      isAgree: false,
    };

    const clickCloseModal = () => {
      agreeDescModal();
      cotext.emit("closeModal");
    };

    const agreeDescModal = () => {
      isVisibleModal.value = false;
    };

    const onSubmit = async () => {
      const { validate } = inquiryRef.value;
      const { valid, errors } = await validate();

      if (!valid) {
        const key = Object.keys(errors)[0];
        alert(errors[key]);
        return false;
      }

      try {
        const { data } = await sugangQaApi(props.pageIdx, inquiryInitValues);

        const { err } = data;
        if (err === 0) {
          alert("문의하기에 성공하였습니다.");
          clickCloseModal();
        } else {
          alert("문의하기에 실패하였습니다.");
        }
      } catch (error) {
        alert("문의하기에 실패하였습니다.");
        console.error("onSubmit Error :", error);
      }
    };

    watch(
      () => props.visible,
      (cur) => {
        if (cur) {
          inquiryInitValues.email = "";
          inquiryInitValues.mobile = "";
          inquiryInitValues.name = "";
          inquiryInitValues.qaContents = "";
          inquiryInitValues.isAgree = false;
        }
      }
    );

    return {
      inquiryRef,
      isVisibleModal,
      agreeDescModal,
      clickCloseModal,
      inquiryInitValues,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: $black, $alpha: 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .popup {
    display: flex;
    flex-direction: column;
    background-color: $white;
    border-radius: 14px;
    padding: 20px 42px 47px 42px;
    width: 500px;
    max-width: 500px;

    .inquriry {
      color: #949494;
      padding: 15px;
      background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
      border: none;

      &:focus {
        border: none;
      }
    }

    .agree-text {
      text-decoration: underline;
    }

    .submit {
      font-weight: $bold;
      color: $white;
      text-align: center;
      background-color: $blue;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      border: none;
    }

    .title-text {
      font-size: 30px;
      font-weight: $bold;
      text-align: center;
      margin-bottom: 40px;
    }

    .close {
      width: 19px;
      align-self: flex-end;
      margin-bottom: 25px;
      cursor: pointer;
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px rgba($color: $gray-dde0e4, $alpha: 0.5) inset;
    }

    .name-wrapper {
      display: flex;
      flex-direction: column;
      gap: 9px 0;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba($color: $black, $alpha: 0.07);

      label {
        font-weight: $bold;
      }

      input {
        font-size: 16px;
        color: $black;
        padding: 15px;
        background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
        border-radius: 8px;

        &::placeholder {
          color: #949494;
        }
      }
    }

    .select-wrapper {
      .tab-title {
        display: flex;
        justify-content: space-between;
        gap: 0 12px;
        margin-bottom: 17px;

        li {
          width: 50%;
          font-size: 14px;
          font-weight: $bold;
          color: #959595;
          text-align: center;
          border: 1px solid #959595;
          border-radius: 8px;
          padding: 13px 0;
          cursor: pointer;

          &.on {
            color: $blue;
            border: 1px solid $blue;
          }
        }
      }

      .tab-sub {
        margin-bottom: 37px;

        .radio-wrapper {
          display: flex;
          gap: 0 17px;
          margin-bottom: 7px;

          li {
            display: flex;
            align-items: center;
            gap: 0 5px;

            input {
              width: 12px;
              height: 12px;
            }

            label {
              font-size: 14px;
              font-weight: $bold;
            }
          }
        }

        .input-wrapper {
          li {
            display: flex;

            input {
              flex-grow: 1;
              font-size: 16px;
              color: #949494;
              padding: 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;
            }

            .country-box {
              flex-grow: 1;
              font-size: 16px;
              color: $black;
              padding: 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;
              display: flex;
              cursor: pointer;
            }

            .item1 {
              width: 10%;
            }

            .item2 {
              width: 80%;
            }

            .item3 {
              width: 10%;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .arrow-img {
              width: 12px;
              height: 9px;
              cursor: pointer;
            }
          }

          .select-country-wrapper {
            gap: 0 12px;
            margin-bottom: 8px;
            position: relative;
            // height: 48px;

            .country-list {
              position: absolute;
              overflow-y: scroll;
              top: 58px;
              left: 0;
              width: 100%;
              transform: scaleY(0);
              background-color: $white;
              border: solid 1px #e7e7e7;
              border-radius: 8px;

              box-shadow: 3.6px 1.8px 40px 0 rgba(0, 0, 0, 0.13);

              &.active {
                transform: scaleY(1);
              }
            }

            .country-list::-webkit-scrollbar {
              width: 3px;
            }

            .country-list::-webkit-scrollbar-thumb {
              background-color: $black;
            }
            .country-list::-webkit-scrollbar-track {
              background-color: $gray-cdcdcd;
            }

            .country-wrap {
              display: flex;
              padding: 10px 10px 0 10px;
            }

            .country-item:hover {
              background-color: $gray-f6f7f8;
            }

            .country-flag {
              width: 10%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }

            .country-text {
              width: 90%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }
          }

          .get-code-wrapper {
            justify-content: space-between;
            gap: 0 12px;
            margin-bottom: 8px;

            p {
              font-size: 14px;
              color: $white;
              text-align: center;
              line-height: 48px;
              padding: 0 17px;
              background-color: $black;
              border-radius: 8px;
              flex: none;
              cursor: pointer;
            }
          }

          .write-code-wrapper {
            flex-direction: column;

            .warning {
              font-size: 14px;
              color: $red;
              margin-top: 10px;
            }
          }
        }
      }

      .ok {
        max-width: 162px;
        margin: 0 auto;
        font-weight: $bold;
        color: $white;
        text-align: center;
        background-color: $blue;
        padding: 16px 0;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
